export default __webpack_public_path__ + "assets/images/5581cfb4e7a276d210aa1089c4e91760.svg";